// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__JV2i3","pendingPaymentIcon":"CalendarEvent_pendingPaymentIcon__3EkJM","gfeWrapper":"CalendarEvent_gfeWrapper__1AyNM"};